/* ============================================================
   ToTheLove — Abonnement Recharge + nichage des tiers
   ------------------------------------------------------------
   Mode sérum (défaut) :
   - abo = force x1 + verrouille les tiers + prix abo épinglé
   - one-time = tiers libres nichés dans la carte achat ponctuel

   Mode cure (data-ttl-sub-pack-on-sub, template cure-3-mois) :
   - achat ponctuel par défaut
   - packs 3/6 mois DANS la carte active :
       • Achat ponctuel → variantes = achat unique
       • Abonnement → même choix 3/6 mois (= variante + selling plan sync)
   - pas de dropdown Recharge 60/90 j (masqué CSS + sync plan)

   Anti-flash : debounce des mutations, pas de re-nichage si déjà OK,
   cooldown pendant un changement de variante (Dawn remount Recharge).
   Cache-bust: 2026-08-14-abo-packs-v7-promo6
   ============================================================ */
(function () {
  var TTL_CURE_BUILD = '20260814v8preview6';
  if (customElements.get('ttl-subscription')) return;

  var TTL_TIER_RADIO = '.product-form__input--pill input[type="radio"]';
  if (!HTMLElement.prototype.focus.ttlNoScrollPatch) {
    var ttlNativeFocus = HTMLElement.prototype.focus;
    var ttlFocus = function (options) {
      if (this && this.matches && this.matches(TTL_TIER_RADIO)) {
        return ttlNativeFocus.call(this, Object.assign({}, options, { preventScroll: true }));
      }
      return ttlNativeFocus.call(this, options);
    };
    ttlFocus.ttlNoScrollPatch = true;
    HTMLElement.prototype.focus = ttlFocus;
  }

  class TtlSubscription extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var tpl = this.querySelector('[data-ttl-sub-tpl]');
      this.extrasTpl = tpl && tpl.content ? tpl.content.querySelector('[data-ttl-sub-extras]') : null;

      this.scope = this.closest('.shopify-section') || document.querySelector('#MainContent') || document.body;
      this.picker = this.scope.querySelector('variant-selects');
      this.lastTierRadio = null;
      this.fixedSubPrice = (this.getAttribute('data-ttl-sub-fixed-price') || '').trim();
      this.packOnSub = this.hasAttribute('data-ttl-sub-pack-on-sub');
      this.defaultSub = this.hasAttribute('data-ttl-sub-default');
      this.defaultOnetime = this.hasAttribute('data-ttl-sub-default-onetime');
      this._defaultTries = 0;
      this._enhancing = false;
      this._enhanceQueued = false;
      this._variantQuietUntil = 0;
      this.packPlans = null;
      if (this.packOnSub) {
        var plansEl = this.querySelector('[data-ttl-pack-plans]');
        if (plansEl) {
          try {
            this.packPlans = JSON.parse(plansEl.textContent || '{}');
          } catch (e) {
            this.packPlans = null;
          }
        }
      }

      if (this.packOnSub) {
        var sectionEl = this.closest('.shopify-section');
        if (sectionEl) sectionEl.classList.add('ttl-pack-on-sub');
      }

      this._enhance = this._enhance.bind(this);
      this._onChange = this._onChange.bind(this);
      this._setSubPrice = this._setSubPrice.bind(this);
      this._onMutations = this._onMutations.bind(this);

      this._enhance();

      this._obs = new MutationObserver(this._onMutations);
      this._obs.observe(this.scope, { childList: true, subtree: true });

      this.scope.addEventListener('change', this._onChange, true);
    }

    disconnectedCallback() {
      if (this._obs) this._obs.disconnect();
      if (this._priceObs) this._priceObs.disconnect();
      if (this._packPriceObs) this._packPriceObs.disconnect();
      if (this._enhanceTimer) clearTimeout(this._enhanceTimer);
      if (this.scope) this.scope.removeEventListener('change', this._onChange, true);
      if (this._holdRelease) this._holdRelease();
    }

    _onMutations() {
      if (this._enhancing) return;
      var self = this;
      var delay = Date.now() < this._variantQuietUntil ? 220 : 120;
      if (this._enhanceTimer) clearTimeout(this._enhanceTimer);
      this._enhanceQueued = true;
      this._enhanceTimer = setTimeout(function () {
        self._enhanceQueued = false;
        self._enhanceTimer = null;
        self._enhance();
      }, delay);
    }

    _enhance() {
      if (this._enhancing) return;
      this._enhancing = true;
      if (this._obs) this._obs.disconnect();

      try {
        this._dedupeRecharge();

        var cards = this.scope.querySelectorAll('[data-option-onetime], [data-option-subsave]');
        for (var i = 0; i < cards.length; i++) this._bindClick(cards[i]);

        var sub = this.scope.querySelector('[data-option-subsave]');
        if (sub && this.extrasTpl && !sub.querySelector('[data-ttl-sub-extras]')) {
          sub.appendChild(this.extrasTpl.cloneNode(true));
        }
        this._bindInfoToggle();

        if (!this.picker || !this.picker.isConnected) {
          this.picker = this.scope.querySelector('variant-selects');
        }

        this._nestPicker();
        this._bindPackClicks();
        this._syncLock();
        this._syncPackMode();
        this._syncSellingPlan();
        this._syncPackPromo();
        this._fixRechargeLabels();
        this._pinSubPrice();
        this._applyDefaultSub();
        this._applyDefaultOnetime();
      } finally {
        this._enhancing = false;
        if (this._obs && this.isConnected) {
          this._obs.observe(this.scope, { childList: true, subtree: true });
        }
      }
    }

    /* Si Dawn/Recharge laisse 2 widgets un instant, on n’en garde qu’un. */
    _dedupeRecharge() {
      var rcs = this.scope.querySelectorAll('.rc-container-wrapper');
      if (rcs.length < 2) return;
      for (var i = 0; i < rcs.length - 1; i++) {
        rcs[i].setAttribute('data-ttl-rc-dup', '');
      }
      rcs[rcs.length - 1].removeAttribute('data-ttl-rc-dup');
    }

    _priceAnchor(price) {
      var anchor = price;
      var el = price.nextElementSibling;
      while (el) {
        var isPriceMeta =
          el.classList.contains('product__tax') ||
          el.classList.contains('volume-pricing-note') ||
          (el.matches && el.matches('div') && el.querySelector('form.installment'));
        if (!isPriceMeta) break;
        anchor = el;
        el = el.nextElementSibling;
      }
      return anchor;
    }

    /* Ordre Cure : UGC macarons → bénéfices → prix → Recharge (jamais sous l’abo). */
    _ensureBuyboxOrder() {
      var benefits = this.scope.querySelector('.ttl-benefits');
      if (!benefits) return;

      /* Sortir les bénéfices s’ils ont glissé dans une carte Recharge. */
      if (benefits.closest('[data-option-onetime], [data-option-subsave], .rc-container-wrapper')) {
        var trappedRc =
          this.scope.querySelector('.rc-container-wrapper:not([data-ttl-rc-dup])') ||
          this.scope.querySelector('.rc-container-wrapper');
        if (trappedRc) trappedRc.before(benefits);
      }

      var macarons = this.scope.querySelector('[data-ttl-macarons]');
      var price = this.scope.querySelector('[id^="price-"]');
      var rc =
        this.scope.querySelector('.rc-container-wrapper:not([data-ttl-rc-dup])') ||
        this.scope.querySelector('.rc-container-wrapper');

      if (macarons) {
        if (benefits.previousElementSibling !== macarons) {
          macarons.after(benefits);
        }
      } else if (price) {
        /* Fallback sans UGC : juste au-dessus du prix. */
        if (benefits.nextElementSibling !== price) {
          price.before(benefits);
        }
      }

      /* Garantir : bénéfices avant prix et avant Recharge. */
      if (price && !(benefits.compareDocumentPosition(price) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        if (macarons) macarons.after(benefits);
        else price.before(benefits);
      }
      if (rc && !(benefits.compareDocumentPosition(rc) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        if (macarons) macarons.after(benefits);
        else rc.before(benefits);
      }
    }

    _nestPicker() {
      if (!this.picker) return;

      if (this.packOnSub) {
        this._ensureBuyboxOrder();

        /* Packs dans la carte active : ponctuel = achat unique, abo = cadence 3/6. */
        var host = this._subActive()
          ? this.scope.querySelector('[data-option-subsave]')
          : this.scope.querySelector('[data-option-onetime]');
        if (!host) return;
        if (this.picker.parentElement === host) {
          /* Garder les packs avant les extras abo (bouton info). */
          var extras = host.querySelector('[data-ttl-sub-extras]');
          if (extras && this.picker.nextElementSibling !== extras) {
            host.insertBefore(this.picker, extras);
          }
          this._ensureBuyboxOrder();
          return;
        }
        var extrasMove = host.querySelector('[data-ttl-sub-extras]');
        if (extrasMove) host.insertBefore(this.picker, extrasMove);
        else host.appendChild(this.picker);
        this._ensureBuyboxOrder();
        return;
      }

      var onetime = this.scope.querySelector('[data-option-onetime]');
      if (onetime && this.picker.parentElement !== onetime) {
        onetime.appendChild(this.picker);
      }
    }

    _syncPackMode() {
      if (!this.packOnSub) return;
      var sectionEl = this.closest('.shopify-section');
      if (!sectionEl) return;
      var onetime = !this._subActive();
      sectionEl.classList.toggle('ttl-pack-mode-onetime', onetime);
      sectionEl.classList.toggle('ttl-pack-mode-sub', !onetime);
      if (this.picker) this.picker.removeAttribute('data-ttl-pack-hidden');
    }

    /* Cure : cadence abo = durée du pack (3→90j / 6→180j si plan Recharge présent). */
    _currentVariantId() {
      var form =
        this.scope.querySelector('form[action*="/cart/add"]') ||
        this.scope.querySelector('product-form form') ||
        (this.picker && this.picker.closest('form'));
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput && idInput.value) return String(idInput.value);

      if (!this.picker || !this.packPlans) return null;
      var checked = this.picker.querySelector('input[type="radio"]:checked');
      if (!checked) return null;
      var optVal = checked.value;
      var keys = Object.keys(this.packPlans);
      for (var i = 0; i < keys.length; i++) {
        var entry = this.packPlans[keys[i]];
        if (entry && entry.option === optVal) return keys[i];
      }
      return null;
    }

    _planIdForVariant(variantId) {
      if (!this.packPlans || !variantId) return null;
      var entry = this.packPlans[variantId];
      if (!entry || entry.planId == null) return null;
      return String(entry.planId);
    }

    _setSellingPlanValue(planId) {
      if (!planId) return false;
      var changed = false;
      var idStr = String(planId);

      /* 1) Input form Dawn (ce que le panier lit vraiment). */
      var inputs = this.scope.querySelectorAll('input[name="selling_plan"]');
      for (var i = 0; i < inputs.length; i++) {
        if (String(inputs[i].value) !== idStr) {
          inputs[i].value = idStr;
          changed = true;
        }
      }

      /* 2) Dropdown Recharge (souvent masqué en mode cure). */
      var sel = this.scope.querySelector('.rc-selling-plans__dropdown');
      if (sel) {
        var opt =
          sel.querySelector('option[value="' + idStr + '"]') ||
          sel.querySelector('option[value="' + idStr + '.0"]');
        if (!opt) {
          var entry = this.packPlans && this.packPlans[this._currentVariantId()];
          var months = entry && entry.months ? entry.months : 0;
          var days = months * 30;
          var options = sel.options;
          for (var j = 0; j < options.length; j++) {
            var t = (options[j].textContent || '').toLowerCase();
            if (
              (days && t.indexOf(String(days)) !== -1) ||
              (months &&
                (t.indexOf(months + ' mois') !== -1 ||
                  t.indexOf(months + '-month') !== -1 ||
                  t.indexOf(months + ' month') !== -1))
            ) {
              opt = options[j];
              break;
            }
          }
        }
        if (opt && sel.value !== opt.value) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          changed = true;
        } else if (opt) {
          idStr = String(opt.value).replace(/\.0$/, '');
        }
      }

      return changed;
    }

    _syncSellingPlan() {
      if (!this.packOnSub || !this._subActive()) return;
      var planId = this._planIdForVariant(this._currentVariantId());
      if (!planId) return;
      this._setSellingPlanValue(planId);
    }

    /* Cure : prix preview carte abo (même en achat ponctuel) + badge −20 %.
       Texte « Détails » masqué CSS — on ne le touche pas. */
    _syncPackPromo() {
      if (!this.packOnSub || !this.packPlans) return;
      var entry = this.packPlans[this._currentVariantId()];
      if (!entry || !entry.priceMoney) return;

      var priceEl = this.scope.querySelector('[data-price-subsave]');
      if (priceEl) {
        this._packSubPrice = String(entry.priceMoney).trim();
        if (priceEl !== this._packPriceEl) {
          if (this._packPriceObs) this._packPriceObs.disconnect();
          this._packPriceEl = priceEl;
          var self = this;
          this._packPriceObs = new MutationObserver(function () {
            if (!self._packSubPrice || !self._packPriceEl) return;
            if (self._packPriceEl.textContent.trim() !== self._packSubPrice) {
              self._packPriceEl.textContent = self._packSubPrice;
            }
          });
          this._packPriceObs.observe(priceEl, { characterData: true, childList: true, subtree: true });
        }
        if (priceEl.textContent.trim() !== this._packSubPrice) {
          priceEl.textContent = this._packSubPrice;
        }
      }

      var subCard = this.scope.querySelector('[data-option-subsave]');
      var badge = subCard && subCard.querySelector('.rc-option__discount');
      if (badge) {
        var raw = (badge.textContent || '').replace(/\s+/g, '');
        if (!raw || raw === '−' || raw === '-') badge.textContent = '20%';
      } else if (subCard) {
        var label = subCard.querySelector('.rc_widget__option__label') || subCard.querySelector('.rc-option__text');
        var textEl = subCard.querySelector('.rc-option__text');
        if (label && textEl && !subCard.querySelector('[data-ttl-pack-discount]')) {
          badge = document.createElement('span');
          badge.className = 'rc-option__discount';
          badge.setAttribute('data-ttl-pack-discount', '1');
          badge.textContent = '20%';
          if (textEl.nextSibling) label.insertBefore(badge, textEl.nextSibling);
          else label.appendChild(badge);
        }
      }
    }

    /* Recharge remonte parfois en EN après un changement de variante. */
    _fixRechargeLabels() {
      if (!this.packOnSub) return;
      var map = [
        { en: /^subscribe\s*&\s*save$/i, fr: "S'abonner et économiser" },
        { en: /^subscribe\s+and\s+save$/i, fr: "S'abonner et économiser" },
        { en: /^subscribe$/i, fr: "S'abonner" },
        { en: /^one[\s-]?time(\s+purchase)?$/i, fr: 'Achat ponctuel' }
      ];
      var nodes = this.scope.querySelectorAll('.rc-option__text');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        /* Ne toucher que les nœuds texte simples (évite d'écraser prix/badge). */
        var onlyText = true;
        var text = '';
        for (var c = 0; c < el.childNodes.length; c++) {
          var n = el.childNodes[c];
          if (n.nodeType === 3) text += n.textContent;
          else if (n.nodeType === 1) {
            onlyText = false;
            break;
          }
        }
        if (!onlyText) continue;
        var raw = text.replace(/\s+/g, ' ').trim();
        if (!raw) continue;
        for (var j = 0; j < map.length; j++) {
          if (map[j].en.test(raw)) {
            el.textContent = map[j].fr;
            break;
          }
        }
      }
    }

    _bindInfoToggle() {
      var roots = this.scope.querySelectorAll('[data-ttl-sub-extras].ttl-sub-extras--info');
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        if (root.dataset.ttlInfoBound) continue;
        root.dataset.ttlInfoBound = '1';
        var btn = root.querySelector('[data-ttl-sub-info-btn]');
        var panel = root.querySelector('[data-ttl-sub-info-panel]');
        if (!btn || !panel) continue;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var open = panel.hasAttribute('hidden');
          if (open) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          root.classList.toggle('is-open', open);
        });
      }
    }

    _applyDefaultSub() {
      if (!this.defaultSub || this.defaultOnetime) return;
      if (this._defaultTries >= 99) return;
      var subRadio = this.scope.querySelector('[data-radio-subsave]');
      if (!subRadio) return;
      if (subRadio.checked) {
        this._defaultTries = 99;
        this._syncLock();
        this._syncPackMode();
        this._syncSellingPlan();
        return;
      }
      if (this._defaultTries >= 8) return;
      this._defaultTries += 1;
      subRadio.click();
    }

    /* Cure : forcer Achat ponctuel (Recharge coche souvent l’abo). */
    _applyDefaultOnetime() {
      if (!this.defaultOnetime) return;
      if (this._defaultTries >= 99) return;
      var oneRadio = this.scope.querySelector('[data-radio-onetime]');
      if (!oneRadio) return;
      if (oneRadio.checked) {
        this._defaultTries = 99;
        this._syncLock();
        this._syncPackMode();
        return;
      }
      if (this._defaultTries >= 8) return;
      this._defaultTries += 1;
      oneRadio.click();
    }

    _bindClick(card) {
      if (card.dataset.ttlClickBound) return;
      card.dataset.ttlClickBound = '1';
      var self = this;
      card.addEventListener('click', function (e) {
        /* Clics dans les packs : ne pas re-dispatcher sur le radio Recharge
           (sinon la durée abo est impossible à changer). */
        if (self.picker && self.picker.contains(e.target)) return;
        if (e.target.closest('select, a, button, label, input, [data-ttl-sub-info-btn], [data-ttl-sub-info-panel]')) return;
        var radio = card.querySelector('.rc-radio__input');
        if (radio && !radio.checked) radio.click();
      });
    }

    _bindPackClicks() {
      if (!this.packOnSub || !this.picker) return;
      if (this.picker.dataset.ttlPackClickBound) return;
      this.picker.dataset.ttlPackClickBound = '1';
      this.picker.addEventListener(
        'click',
        function (e) {
          e.stopPropagation();
        },
        true
      );
    }

    _subActive() {
      var sub = this.scope.querySelector('[data-radio-subsave]');
      return !!(sub && sub.checked);
    }

    _syncLock() {
      if (!this.picker) return;
      /* Cure : durée libre quel que soit abo/unique. Sérum : lock pendant abo. */
      var locked = this.packOnSub ? false : this._subActive();
      if (this.picker.hasAttribute('data-ttl-tiers-locked') !== locked) {
        this.picker.toggleAttribute('data-ttl-tiers-locked', locked);
      }
    }

    _onChange(e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;

      /* Changement de pack = Dawn remount Recharge → on laisse passer le calm-down. */
      if (this.picker && this.picker.contains(t)) {
        this._variantQuietUntil = Date.now() + 450;
        if (this.packOnSub) this.lastTierRadio = t;
        else if (!this._subActive()) this.lastTierRadio = t;
        if (this.packOnSub) {
          var self = this;
          setTimeout(function () {
            self._syncSellingPlan();
            self._syncPackPromo();
            self._fixRechargeLabels();
          }, 280);
          setTimeout(function () {
            self._syncPackPromo();
          }, 600);
        }
        return;
      }

      if (t.matches && t.matches('[data-radio-subsave]') && t.checked) {
        this._nestPicker();
        this._syncLock();
        this._syncPackMode();
        /* Sérum : abo = x1. Cure : on garde la durée choisie. */
        if (!this.packOnSub) this._forceSingle();
        else {
          this._syncSellingPlan();
          this._syncPackPromo();
        }
      } else if (t.matches && t.matches('[data-radio-onetime]') && t.checked) {
        this._nestPicker();
        this._syncLock();
        this._syncPackMode();
        /* Sérum : restaure le tier one-time. Cure : durée déjà libre. */
        if (!this.packOnSub) this._restoreTier();
        else this._syncPackPromo();
      }
    }

    _selectTier(radio) {
      if (!radio || radio.checked) return;
      this._holdScroll(window.scrollY);
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    _holdScroll(y) {
      var EVENTS = ['wheel', 'touchmove', 'keydown', 'pointerdown'];
      var self = this;
      var cancelled = false;

      if (this._holdRelease) this._holdRelease();

      var release = function () {
        if (cancelled) return;
        cancelled = true;
        for (var i = 0; i < EVENTS.length; i++) {
          window.removeEventListener(EVENTS[i], release, true);
        }
        if (self._holdRelease === release) self._holdRelease = null;
      };
      for (var i = 0; i < EVENTS.length; i++) {
        window.addEventListener(EVENTS[i], release, { capture: true, passive: true });
      }
      this._holdRelease = release;

      var t0 = window.performance && performance.now ? performance.now() : Date.now();
      var tick = function () {
        if (cancelled) return;
        if (window.scrollY !== y) window.scrollTo({ top: y, behavior: 'instant' });
        var now = window.performance && performance.now ? performance.now() : Date.now();
        if (now - t0 < 600) requestAnimationFrame(tick);
        else release();
      };
      requestAnimationFrame(tick);
    }

    _forceSingle() {
      if (!this.picker) return;
      var first =
        this.picker.querySelector('input[type="radio"]:not([disabled]):not(.disabled)') ||
        this.picker.querySelector('input[type="radio"]');
      this._selectTier(first);
    }

    _restoreTier() {
      if (this.lastTierRadio && this.lastTierRadio.isConnected) {
        this._selectTier(this.lastTierRadio);
      }
    }

    _pinSubPrice() {
      if (!this.fixedSubPrice) return;
      var el = this.scope.querySelector('[data-price-subsave]');
      if (!el) return;
      if (el !== this._priceEl) {
        if (this._priceObs) this._priceObs.disconnect();
        this._priceEl = el;
        this._priceObs = new MutationObserver(this._setSubPrice);
        this._priceObs.observe(el, { characterData: true, childList: true, subtree: true });
      }
      this._setSubPrice();
    }

    _setSubPrice() {
      if (this._priceEl && this._priceEl.textContent.trim() !== this.fixedSubPrice) {
        this._priceEl.textContent = this.fixedSubPrice;
      }
    }
  }

  customElements.define('ttl-subscription', TtlSubscription);
})();

/* TTL — scroll CTA « Le calcul » → buy box (sans # dans l’URL) */
(function () {
  if (window.__ttlCalculScroll) return;
  window.__ttlCalculScroll = true;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 56;
  }

  function resolveTarget(id) {
    if (id) {
      var byId = document.getElementById(id);
      if (byId) return byId;
    }
    return (
      document.querySelector('[data-ttl-buybox]') ||
      document.getElementById('ttl-buybox') ||
      document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('product-info')
    );
  }

  function scrollToTarget(target) {
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  function targetIdFromEl(el) {
    var raw = (el && (el.getAttribute('data-ttl-scroll-to') || el.getAttribute('href'))) || 'ttl-buybox';
    raw = String(raw).replace(/^#/, '').trim();
    if (!raw || raw === 'ProductInfo-main') return 'ttl-buybox';
    return raw;
  }

  document.addEventListener(
    'click',
    function (event) {
      var el =
        event.target &&
        event.target.closest &&
        event.target.closest('[data-ttl-scroll-to], a.ttl-calcul__btn, button.ttl-calcul__btn');
      if (!el) return;
      event.preventDefault();
      event.stopPropagation();
      scrollToTarget(resolveTarget(targetIdFromEl(el)));
    },
    true
  );
})();
/* ttl-build-20260814v8-preview6 */
